import type { FlattenSimpleInterpolation } from "styled-components"
import styled from "styled-components"

export const Wrapper = styled.div<{ css?: FlattenSimpleInterpolation }>`
  ${({ css }) => css}
`
